import { render, staticRenderFns } from "./WidgetOrgList.vue?vue&type=template&id=70d163d2&scoped=true&"
import script from "./WidgetOrgList.vue?vue&type=script&lang=js&"
export * from "./WidgetOrgList.vue?vue&type=script&lang=js&"
import style0 from "./WidgetOrgList.vue?vue&type=style&index=0&id=70d163d2&prod&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./WidgetOrgList.vue?vue&type=style&index=2&id=70d163d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d163d2",
  null
  
)

export default component.exports